import { formatError } from "./formatError";

export const getErrorMessage = (error?: unknown): string => {
  return formatError(error).message;
};
